import React, { Component } from "react";

import Modal from "../../../../components/modal";
import Image from "../../../../components/image";
import provisionalModuleDataBasedOnLanguage from "../../searchList/provisionalModuleDataBasedOnLanguage";

export default class GalleryModal extends Component {
  render(){
    const { props } = this;
    const { open, closeFn, images, size = "medium", language = "nb-NO" } = props;

    const moduleData = provisionalModuleDataBasedOnLanguage(language)
    return(
      <Modal open={open} closeFn={closeFn} size={size}>
        <div className="grid grid-cols-2 grid-rows-gallery gap-2 relative">
          {images.map((image, index) => {
            let path = `https://public-assets.spotliodata.com/`;
            if (image.image) path += image.image.filename_disk;
            if (image.directus_files_id) path += image.directus_files_id.filename_disk;
            if (image.filename_disk) path += image.filename_disk;
            let styles = '';
            /* Finish this when time is available */
            // Calculate the aspect ratio of the image
            // const aspectRatio = image.width / image.height;
            // Set a threshold value for the aspect ratio
            // const lowThreshold = 1.2;
            // const highThreshold = 1.4;

            // Apply col-span or row-span based on aspect ratio
            // if (aspectRatio <= lowThreshold) styles = 'row-span-2 col-span-1';
            // else if (aspectRatio >= highThreshold) styles = 'col-span-2 row-span-1';
            /*else*/ styles = 'col-span-1 row-span-1';
            if (index + 1 === images.length && (images.length % 2) ) styles = 'col-span-2 row-span-2';

            return (
              <div key={index} className={`relative overflow-hidden ${styles} rounded-lg`}>
                <Image
                  src={path}
                  alt={index}
                  className="w-full h-full object-cover"
                />
              </div>
            );
          })}
        </div>
        <button className="bg-[color:var(--primaryColor)] text-[color:var(--secondaryColor)] rounded-2xl flex items-center text-sm p-4 w-24 h-10 justify-center sticky bottom-3 left-1/2 transform -translate-x-1/2 font-[800] text-[0.8125rem] leading-[1.01875rem]" onClick={closeFn}>
          {moduleData.closeButton}
        </button>

      </Modal>
    )
  }
}